// Shared feature IDs, from @m3-tech/boss-types. OptnsIQ (AssistantIQ) opens only
// in the modern deal screen, so its Default Deal Section option needs both, as the
// deal sidebar entry does.
export { FEATURE_ASSISTANTIQ, FEATURE_DEAL_BOSS_MODERNIZATION } from '@m3-tech/boss-types'

export const FEATURE_SETTINGS = 100
export const FEATURE_SYSTEM_SETTINGS = 101
export const FEATURE_PERSONAL_SETTINGS = 102
export const FEATURE_PERSONAL_INFO = 103
export const FEATURE_PROVINCIAL_TAX_RATE = 104
export const FEATURE_MARKETING_CRM_SETTINGS = 105
export const FEATURE_MARKETING_INFO = 106
export const FEATURE_MOPOLO = 107
export const FEATURE_AUTO_COMMUNICATION = 108
export const FEATURE_CUSTOM_SIGNATURE = 109
export const FEATURE_USER_SETTINGS = 110
export const FEATURE_SECURITY_SETTINGS = 111
export const FEATURE_REVENUE_SETTINGS = 112
export const FEATURE_COMMISSION_REPORTS_PASSWORD = 113
export const FEATURE_GROSS_COMMISSION_VISIBILITY = 114
export const FEATURE_WEBSITE = 115
export const FEATURE_BROKER_RATES = 116
export const FEATURE_MAILCHIMP = 117
export const FEATURE_INTEGRATION_SETTINGS = 119
export const FEATURE_CUSTOMER_PORTAL_SETTINGS = 120
// Customer Portal Settings > Customer Portal — the /customer-portal page.
export const FEATURE_CUSTOMER_PORTAL_SETTINGS_SUBITEM = 121
export const FEATURE_CTP_PLATFORM_DEFAULTS = 122
export const FEATURE_CTP_PLATFORM_DOCUMENTS = 123
export const FEATURE_CTP_DOCUMENT_LIST = 124
export const FEATURE_CTP_RULES = 126
export const FEATURE_CTP_PLATFORM_EMAILS = 127
export const FEATURE_CTP_PLATFORM_NOTIFICATIONS = 128
export const FEATURE_DEAL_PARTICIPANT_DEFAULTS = 129
export const FEATURE_CTP_SETTINGS_CTP_REVIEW = 130
export const FEATURE_PRESET_COMMISSION = 450
export const FEATURE_NEW_PRESET_COMMISSION = 451
export const FEATURE_LA_GRILLE = 467
export const FEATURE_TEMPLATED_TASKS = 1102
// Task-template builder trigger-field feature gates (legacy OtherConstants.js:537-538).
// Not exported as FEATURE_* by boss-types, so defined locally here.
export const FEATURE_TASK_CREATION_TRIGGER_FIELDS = 1104
export const FEATURE_TASK_COMPLETION_TRIGGER_FIELDS = 1105
